import {createContext, useContext} from "react";
import {IRoot, Root} from "./root";

const store = new Root()

export interface IStore extends IRoot {
}

export const StoreContext = createContext<IStore>(store)

export const useStore = (): IStore => useContext(StoreContext)

export default store
